/* Dr.Shampoo — JS global (vanilla, sem dependências)
   Carrinho (Cart AJAX + Section Rendering), drawer, toast, steppers,
   barras de portes grátis, hero slider, pesquisa preditiva, nav mobile. */
(function () {
  'use strict';

  var D = document;
  var S = window.dsStrings || {};

  function fmtMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  window.dsFmtMoney = fmtMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = D.getElementById('ds-toast');
    if (!el) {
      el = D.createElement('div');
      el.id = 'ds-toast';
      D.body.appendChild(el);
    }
    el.className = 'ds-toast';
    el.innerHTML = '<span class="ds-toast__check">✓</span> ' + msg;
    el.style.display = 'flex';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.style.display = 'none';
    }, 2600);
  }
  window.dsToast = toast;

  /* ---------- Drawer ---------- */
  function getDrawer() {
    return D.getElementById('ds-cart-drawer-root');
  }
  function openDrawer() {
    var root = getDrawer();
    if (!root) return;
    root.classList.add('is-open');
    D.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var root = getDrawer();
    if (!root) return;
    root.classList.remove('is-open');
    D.documentElement.style.overflow = '';
  }
  window.dsOpenCart = openDrawer;

  /* ---------- Section refresh ---------- */
  function refreshableIds() {
    var ids = [];
    D.querySelectorAll('[data-ds-refresh]').forEach(function (el) {
      var id = el.getAttribute('data-ds-refresh');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }
  function applySections(sections) {
    if (!sections) return;
    var drawer = getDrawer();
    var wasOpen = drawer && drawer.classList.contains('is-open');
    Object.keys(sections).forEach(function (id) {
      var host = D.getElementById('shopify-section-' + id);
      if (!host || !sections[id]) return;
      var tpl = D.createElement('template');
      tpl.innerHTML = sections[id];
      var fresh = tpl.content.querySelector('#shopify-section-' + id) || tpl.content.firstElementChild;
      if (fresh) host.innerHTML = fresh.innerHTML;
    });
    if (wasOpen) {
      var freshDrawer = getDrawer();
      if (freshDrawer) freshDrawer.classList.add('is-open');
    }
    wishSync();
  }

  /* ---------- Cart state ---------- */
  function broadcast(cart) {
    if (!cart) return;
    D.querySelectorAll('[data-ds-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count > 0 ? cart.item_count : '';
    });
    updateShipBars(cart.items_subtotal_price);
    D.dispatchEvent(new CustomEvent('ds:cart', { detail: cart }));
  }
  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      broadcast(cart);
      return cart;
    });
  }
  window.dsFetchCart = fetchCart;

  function cartRequest(url, payload) {
    payload.sections = refreshableIds().join(',');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        applySections(data.sections);
        return fetchCart().then(function (cart) { return { data: data, cart: cart }; });
      });
    });
  }

  function addItems(items, opts) {
    opts = opts || {};
    return cartRequest('/cart/add.js', { items: items })
      .then(function (res) {
        if (opts.quiet) toast(opts.message || S.added_to_cart || 'Adicionado ao carrinho');
        else openDrawer();
        return res;
      })
      .catch(function (err) {
        toast((err && err.description) || S.cart_add_error || 'Não foi possível adicionar ao carrinho');
      });
  }
  window.dsAddItems = addItems;

  function changeLine(lineKey, quantity) {
    return cartRequest('/cart/change.js', { id: lineKey, quantity: quantity }).catch(function (err) {
      toast((err && err.message) || S.cart_update_error || 'Não foi possível atualizar o carrinho');
    });
  }

  /* ---------- Barras de portes grátis ---------- */
  function updateShipBars(subtotalCents) {
    D.querySelectorAll('[data-ds-shipbar]').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      var region = bar.getAttribute('data-region') || 'Pt. Continental';
      var msgEl = bar.querySelector('[data-ds-shipbar-msg]');
      var fillEl = bar.querySelector('[data-ds-shipbar-fill]');
      if (!msgEl || !fillEl) return;
      var free = subtotalCents >= threshold && subtotalCents > 0;
      var msg;
      if (subtotalCents === 0) {
        msg = (S.free_shipping_above || 'Portes grátis em compras superiores a %amount% para %region%')
          .replace('%amount%', fmtMoney(threshold))
          .replace('%region%', region);
      } else if (free) {
        msg = '✓ ' + (S.free_shipping_reached || 'Parabéns! Tem portes grátis');
      } else {
        msg = (S.free_shipping_remaining || 'Faltam %amount% para portes grátis')
          .replace('%amount%', fmtMoney(threshold - subtotalCents));
      }
      msgEl.textContent = msg;
      msgEl.classList.toggle('is-free', free);
      fillEl.style.width = Math.min(100, (subtotalCents / threshold) * 100) + '%';
    });
  }

  /* ---------- Delegação de cliques ---------- */
  D.addEventListener('click', function (e) {
    var t;

    /* Fecha o dropdown de ordenação ao clicar fora dele */
    if (!e.target.closest('[data-ds-sorts-wrap]')) {
      D.querySelectorAll('[data-ds-sorts-wrap].is-open').forEach(function (w) {
        w.classList.remove('is-open');
        var b = w.querySelector('[data-ds-sorts-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    if (e.target.closest('[data-ds-open-cart]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-ds-close-cart]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    /* ATC simples (cards, upsell): botão com data-ds-add="variantId" */
    t = e.target.closest('[data-ds-add]');
    if (t) {
      e.preventDefault();
      var vid = parseInt(t.getAttribute('data-ds-add'), 10);
      var quiet = t.hasAttribute('data-ds-quiet');
      t.disabled = true;
      addItems([{ id: vid, quantity: 1 }], { quiet: quiet }).then(function () {
        t.disabled = false;
      });
      return;
    }

    /* Steppers de linha do carrinho: data-ds-line-qty="key" data-step="1|-1" */
    t = e.target.closest('[data-ds-line-step]');
    if (t) {
      e.preventDefault();
      var key = t.getAttribute('data-ds-line-key');
      var current = parseInt(t.getAttribute('data-ds-line-qty'), 10);
      var step = parseInt(t.getAttribute('data-ds-line-step'), 10);
      var next = Math.max(0, current + step);
      if (next === current) return;
      changeLine(key, next);
      return;
    }
    t = e.target.closest('[data-ds-line-remove]');
    if (t) {
      e.preventDefault();
      changeLine(t.getAttribute('data-ds-line-remove'), 0);
      return;
    }

    /* Nav mobile */
    if (e.target.closest('[data-ds-nav-open]')) {
      var nav = D.getElementById('ds-mobile-nav');
      if (nav) {
        nav.setAttribute('open', '');
        nav.setAttribute('aria-hidden', 'false');
        nav.removeAttribute('inert');
        D.documentElement.style.overflow = 'hidden';
      }
      return;
    }
    if (e.target.closest('[data-ds-nav-close]')) {
      closeMobileNav();
      return;
    }

    /* Drilldown do menu mobile */
    t = e.target.closest('[data-ds-view-open]');
    if (t) {
      navStack.push(t.getAttribute('data-ds-view-open'));
      syncNavViews();
      return;
    }
    if (e.target.closest('[data-ds-view-back]')) {
      navStack.pop();
      syncNavViews();
      return;
    }

    /* Toggle de filtros (mobile, sidebar esquerda) */
    t = e.target.closest('[data-ds-filters-toggle]');
    if (t) {
      var panel = D.querySelector('.ds-filters');
      var backdrop = D.querySelector('.ds-filters-backdrop');
      if (panel) {
        var open = panel.classList.toggle('is-open');
        if (backdrop) backdrop.classList.toggle('is-open', open);
        D.documentElement.style.overflow = open ? 'hidden' : '';
      }
      return;
    }

    /* Ordenação em mobile: botão único abre dropdown */
    t = e.target.closest('[data-ds-sorts-toggle]');
    if (t) {
      var swrap = t.closest('[data-ds-sorts-wrap]');
      if (swrap) {
        var sopen = swrap.classList.toggle('is-open');
        t.setAttribute('aria-expanded', sopen ? 'true' : 'false');
      }
      return;
    }
  });

  /* ---------- Menu mobile: pilha de vistas ---------- */
  var navStack = [];
  function syncNavViews() {
    var nav = D.getElementById('ds-mobile-nav');
    if (!nav) return;
    var active = navStack.length ? navStack[navStack.length - 1] : 'root';
    nav.querySelectorAll('[data-ds-view]').forEach(function (view) {
      var id = view.getAttribute('data-ds-view');
      view.classList.remove('is-active', 'is-under');
      if (id === active) view.classList.add('is-active');
      else if (id === 'root' || navStack.indexOf(id) !== -1) view.classList.add('is-under');
    });
  }
  function closeMobileNav() {
    var nav = D.getElementById('ds-mobile-nav');
    if (!nav) return;
    nav.removeAttribute('open');
    nav.setAttribute('aria-hidden', 'true');
    nav.setAttribute('inert', '');
    D.documentElement.style.overflow = '';
    navStack = [];
    setTimeout(syncNavViews, 300);
  }

  D.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeMobileNav();
      closeSearchPanel();
      var ms = D.getElementById('ds-msearch');
      if (ms) ms.hidden = true;
    }
  });

  /* ---------- Localização: submeter no change + popover do topbar ---------- */
  D.addEventListener('change', function (e) {
    if (e.target.matches('[data-ds-localization]')) {
      var locForm = e.target.closest('form');
      if (locForm) locForm.submit();
    }
  });
  D.addEventListener('click', function (e) {
    var choice = e.target.closest('[data-ds-loc-choice]');
    if (choice) {
      var form = choice.closest('form');
      var input = form && form.querySelector('[data-ds-loc-input]');
      if (input) {
        input.value = choice.getAttribute('data-ds-loc-choice');
        form.submit();
      }
      return;
    }
    var toggle = e.target.closest('[data-ds-loc-toggle]');
    if (toggle) {
      var pop = toggle.parentElement.querySelector('.ds-loc-pop');
      if (pop) pop.hidden = !pop.hidden;
      return;
    }
    if (!e.target.closest('.ds-loc-pop')) {
      D.querySelectorAll('.ds-loc-pop').forEach(function (p) { p.hidden = true; });
    }
  });

  /* ---------- Upsell do drawer: setas + relacionados automáticos ---------- */
  D.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-ds-upsell-prev]');
    var next = e.target.closest('[data-ds-upsell-next]');
    if (!prev && !next) return;
    var wrap = (prev || next).closest('.ds-drawer__upsell-wrap');
    var row = wrap && wrap.querySelector('[data-ds-upsell-row]');
    if (row) row.scrollBy({ left: prev ? -170 : 170, behavior: 'smooth' });
  });

  D.addEventListener('click', function (e) {
    var sprev = e.target.closest('[data-ds-scroll-prev]');
    var snext = e.target.closest('[data-ds-scroll-next]');
    if (!sprev && !snext) return;
    var swrap = (sprev || snext).closest('[data-ds-scroll-wrap]');
    var srow = swrap && swrap.querySelector('[data-ds-scroll]');
    if (srow) srow.scrollBy({ left: (sprev ? -0.7 : 0.7) * srow.clientWidth, behavior: 'smooth' });
  });

  /* Setas só quando são precisas; a da esquerda só depois de avançar */
  function initScrollWraps() {
    D.querySelectorAll('[data-ds-scroll-wrap]').forEach(function (wrap) {
      var row = wrap.querySelector('[data-ds-scroll]');
      var prev = wrap.querySelector('[data-ds-scroll-prev]');
      var next = wrap.querySelector('[data-ds-scroll-next]');
      if (!row || !prev || !next) return;
      function sync() {
        var overflow = row.scrollWidth > row.clientWidth + 4;
        prev.hidden = !overflow;
        next.hidden = !overflow;
        if (!overflow) return;
        prev.classList.toggle('is-off', row.scrollLeft <= 4);
        next.classList.toggle('is-off', row.scrollLeft >= row.scrollWidth - row.clientWidth - 4);
      }
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function fillRelatedUpsell() {
    var host = D.querySelector('[data-ds-upsell-related]');
    if (!host || host.getAttribute('data-filled')) return;
    host.setAttribute('data-filled', '1');
    var pid = host.getAttribute('data-first-pid');
    var inCart = (host.getAttribute('data-cart-pids') || '').split(',');
    var maxPrice = parseInt(host.getAttribute('data-max-price'), 10) || 0;
    if (!pid) return;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var html = '';
        var added = 0;
        (data.products || []).forEach(function (p) {
          if (added >= 6) return;
          if (inCart.indexOf(String(p.id)) !== -1) return;
          if (!p.available || !p.featured_image) return;
          if (maxPrice > 0 && p.price > maxPrice) return;
          var v = p.variants && p.variants[0];
          if (!v) return;
          var img = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=168';
          html += '<div class="ds-upsell-card">' +
            '<a class="ds-upsell-card__img" href="' + p.url + '"><img src="' + img + '" width="84" height="84" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></a>' +
            '<div class="ds-upsell-card__title">' + p.title + '</div>' +
            '<div class="ds-upsell-card__row">' +
            '<span class="ds-upsell-card__price">' + fmtMoney(p.price) + '</span>' +
            '<button class="ds-upsell-card__add" type="button" data-ds-add="' + v.id + '" aria-label="' + (S.add || 'Adicionar') + '">+</button>' +
            '</div></div>';
          added++;
        });
        if (added > 0) {
          var row = host.querySelector('[data-ds-upsell-row]');
          if (row) row.innerHTML = html;
          host.hidden = false;
        }
      })
      .catch(function () {});
  }
  D.addEventListener('ds:cart', fillRelatedUpsell);

  /* ---------- Filtros: submissão automática ---------- */
  D.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-ds-filters-form]');
    if (!form || !e.target.matches('input')) return;

    /* Faixas de preço: single-select → inputs escondidos gte/lte */
    if (e.target.hasAttribute('data-ds-price')) {
      var gteInput = form.querySelector('[data-ds-price-gte]');
      var lteInput = form.querySelector('[data-ds-price-lte]');
      form.querySelectorAll('[data-ds-price]').forEach(function (cb) {
        if (cb !== e.target) cb.checked = false;
      });
      if (e.target.checked) {
        var gte = e.target.getAttribute('data-gte');
        var lte = e.target.getAttribute('data-lte');
        gteInput.disabled = !gte;
        gteInput.value = gte || '';
        lteInput.disabled = !lte;
        lteInput.value = lte || '';
      } else {
        gteInput.disabled = true;
        lteInput.disabled = true;
      }
    }
    form.submit();
  });

  /* ---------- Ordenação preservando filtros ---------- */
  D.addEventListener('click', function (e) {
    var sort = e.target.closest('[data-ds-sort]');
    if (!sort) return;
    e.preventDefault();
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', sort.getAttribute('data-ds-sort'));
    params.delete('page');
    window.location.search = params.toString();
  });

  /* ---------- Hero slider ---------- */
  function initHero() {
    D.querySelectorAll('[data-ds-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('.ds-hero__slide');
      var dots = hero.querySelectorAll('.ds-hero__dot');
      if (slides.length < 2) return;
      var idx = 0;
      var timer;
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5500;
      function show(i) {
        idx = i % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      }
      function play() {
        clearInterval(timer);
        timer = setInterval(function () { show(idx + 1); }, interval);
      }
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () { show(j); play(); });
      });
      play();
    });
  }

  /* ---------- Pesquisa (preditiva, desktop + overlay mobile) ---------- */
  function closeSearchPanel() {
    D.querySelectorAll('[data-ds-search] .ds-search-panel').forEach(function (p) { p.hidden = true; });
    var bd = D.getElementById('ds-search-backdrop');
    if (bd) bd.hidden = true;
  }
  function hasContent(el) {
    return el && el.textContent.trim().length > 0;
  }
  function initSearchWrap(wrap) {
    var panel = wrap.querySelector('.ds-search-panel');
    var input = wrap.querySelector('input[name="q"]');
    var results = wrap.querySelector('[data-ds-search-results]');
    var idle = wrap.querySelector('[data-ds-search-idle]');
    if (!input || !panel) return;
    var debounce;

    function maybeOpen() {
      if (hasContent(idle) || hasContent(results)) {
        panel.hidden = false;
        var bd = D.getElementById('ds-search-backdrop');
        if (bd && !wrap.closest('.ds-msearch')) bd.hidden = false;
      }
    }
    input.addEventListener('focus', maybeOpen);
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounce);
      if (!q) {
        if (idle) idle.hidden = false;
        if (results) results.innerHTML = '';
        maybeOpen();
        return;
      }
      debounce = setTimeout(function () {
        var types = wrap.getAttribute('data-types') || 'product';
        var url = ((window.Theme && Theme.routes.predictive_search_url) || '/search/suggest') +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=' + encodeURIComponent(types) +
          '&resources[limit]=6&section_id=ds-predictive-results';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tpl = D.createElement('template');
            tpl.innerHTML = html;
            var inner = tpl.content.querySelector('[data-ds-predictive-inner]');
            if (results && inner) {
              results.innerHTML = inner.innerHTML;
              if (idle) idle.hidden = true;
              panel.hidden = false;
            }
          })
          .catch(function () {});
      }, 250);
    });
  }
  function initSearch() {
    D.querySelectorAll('[data-ds-search]').forEach(initSearchWrap);
    var bd = D.getElementById('ds-search-backdrop');
    if (bd) bd.addEventListener('click', closeSearchPanel);
  }

  /* ---------- Pesquisa mobile (overlay) ---------- */
  D.addEventListener('click', function (e) {
    if (e.target.closest('[data-ds-msearch-toggle]')) {
      var ms = D.getElementById('ds-msearch');
      if (!ms) return;
      ms.hidden = !ms.hidden;
      if (!ms.hidden) {
        var inp = ms.querySelector('input[name="q"]');
        if (inp) inp.focus();
      }
    }
  });

  /* ---------- Favoritos (wishlist nativa) ---------- */
  var WISH_KEY = 'ds:wishlist';
  function wishList() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
    } catch (err) {
      return [];
    }
  }
  function wishSave(list) {
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (err) { /* quota */ }
    wishSync();
  }
  function wishSync() {
    var list = wishList();
    D.querySelectorAll('[data-ds-wish-count]').forEach(function (el) {
      el.textContent = list.length > 0 ? list.length : '';
    });
    D.querySelectorAll('[data-ds-wish]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-ds-wish')) !== -1);
    });
    D.dispatchEvent(new CustomEvent('ds:wishlist', { detail: { list: list } }));
  }
  window.dsWishlist = { list: wishList, sync: wishSync };
  D.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ds-wish]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-ds-wish');
    var list = wishList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.unshift(handle);
      toast('Adicionado aos favoritos');
    } else {
      list.splice(idx, 1);
      toast('Removido dos favoritos');
    }
    wishSave(list);
  });

  /* ---------- Card builder partilhado (vistos recentemente, favoritos) ---------- */
  window.dsBuildCard = function (p, opts) {
    opts = opts || {};
    if (!p || !p.featured_image) return '';
    var img = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var promo = p.compare_at_price && p.compare_at_price > p.price;
    var vid = p.variants && p.variants.length === 1 ? p.variants[0].id : null;
    var html = '<div class="ds-card">';
    if (promo) {
      var pct = Math.round((1 - p.price / p.compare_at_price) * 100);
      var cb = window.dsCardBadge || { shape: 'circle', showRrp: false, size: 46, rrp: 'SOBRE PVPR' };
      html += '<span class="ds-badge ds-badge--' + cb.shape + ' ds-card__badge" style="--ds-badge-size:' + (cb.size || 46) + 'px">' +
        '<span class="ds-badge__pct">-' + pct + '%</span>' +
        (cb.showRrp ? '<span class="ds-badge__rrp">' + cb.rrp + '</span>' : '') +
        '</span>';
    }
    if (opts.wish) {
      html += '<button class="ds-wish-btn ds-card__wish" type="button" data-ds-wish="' + p.handle + '" aria-label="' + (S.wishlist || 'Favoritos') + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 20l-7.2-7.2a4.8 4.8 0 016.8-6.8l.4.4.4-.4a4.8 4.8 0 016.8 6.8L12 20z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></button>';
    }
    html += '<a class="ds-card__media" href="' + p.url + '"><img src="' + img + '" width="400" height="400" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></a>' +
      '<div class="ds-card__body">' +
      '<span class="ds-card__brand">' + (p.vendor || '') + '</span>' +
      '<a class="ds-card__title" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="ds-card__prices"><span class="ds-card__price">' + fmtMoney(p.price) + '</span>' +
      (promo ? '<span class="ds-card__old">' + fmtMoney(p.compare_at_price) + '</span><sup class="ds-card__pvpr">*' + (S.rrp || 'PVPR') + '</sup>' : '') +
      '</div>';
    if (opts.atc && vid && p.available) {
      html += '<button class="ds-card__atc" type="button" data-ds-add="' + vid + '">' + (S.add_to_cart || 'Adicionar ao carrinho') + '</button>';
    }
    html += '</div></div>';
    return html;
  };

  /* ---------- Descrição de coleção: "Ler mais" ---------- */
  function initClamp() {
    var desc = D.querySelector('[data-ds-clamp]');
    var toggle = D.querySelector('[data-ds-clamp-toggle]');
    if (!desc || !toggle) return;
    if (desc.scrollHeight > desc.clientHeight + 4) toggle.hidden = false;
    toggle.addEventListener('click', function () {
      var clamped = desc.classList.toggle('is-clamped');
      toggle.querySelector('[data-ds-clamp-more]').hidden = !clamped;
      toggle.querySelector('[data-ds-clamp-less]').hidden = clamped;
    });
  }

  /* ---------- Newsletter: botão ativo só depois de aceitar os termos ---------- */
  function syncNewsletterButtons() {
    D.querySelectorAll('[data-ds-nl-check]').forEach(function (check) {
      var form = check.closest('form');
      var btn = form && form.querySelector('[data-ds-nl-submit]');
      if (btn) btn.disabled = !check.checked;
    });
  }
  D.addEventListener('change', function (e) {
    if (e.target.matches('[data-ds-nl-check]')) syncNewsletterButtons();
  });

  /* ---------- Scroll para o bloco de avaliações (Judge.me) ---------- */
  function findReviewsTarget() {
    var el =
      D.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg, #shopify-product-reviews, [data-review-widget]') ||
      D.getElementById('ds-reviews');
    if (!el) return null;
    /* O CSS do Judge.me esconde o widget (display:none) até o script dele
       iniciar: o rect vem a zeros e o scroll não sai do sítio. A secção
       envolvente nunca está escondida e ocupa a mesma posição no fluxo. */
    if (!el.getClientRects().length) el = el.closest('.shopify-section') || el;
    return el;
  }
  function smoothScrollTo(target) {
    if (!target) return;
    /* scrollIntoView resolve sozinho o contentor que faz scroll (janela,
       wrapper com overflow, iframe do editor) — window.scrollTo não. */
    target.style.scrollMarginTop = '110px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  /* capture:true — apps de terceiros não conseguem travar com stopPropagation */
  D.addEventListener('click', function (e) {
    var goto = e.target.closest('[data-ds-goto-reviews]');
    if (!goto) return;
    e.preventDefault();
    var href = goto.getAttribute('href') || '';
    var attempts = 0;
    function goToReviews() {
      var target = findReviewsTarget();
      if (target) {
        smoothScrollTo(target);
        if (href.charAt(0) === '#') window.history.replaceState(null, '', href);
        else if (target.id) window.history.replaceState(null, '', '#' + target.id);
        return;
      }
      attempts += 1;
      if (attempts < 20) setTimeout(goToReviews, 250);
      else if (href.charAt(0) === '#') window.location.hash = href;
    }
    goToReviews();
  }, true);

  /* ---------- "Ver mais" da descrição breve: abre o acordeão da descrição ---------- */
  D.addEventListener('click', function (e) {
    var more = e.target.closest('[data-ds-open-desc]');
    if (!more) return;
    e.preventDefault();
    var det = D.querySelector('details[data-ds-desc-acc]');
    if (!det) return;
    det.open = true;
    smoothScrollTo(det);
  }, true);

  /* ---------- Footer: menus colapsáveis só em mobile ---------- */
  function syncFooterDetails() {
    var desktop = window.matchMedia('(min-width: 990px)').matches;
    D.querySelectorAll('.ds-footer details[data-ds-fcol]').forEach(function (det) {
      if (desktop) det.setAttribute('open', '');
      else det.removeAttribute('open');
    });
  }

  /* ---------- Steppers genéricos (produto) ---------- */
  D.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ds-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-ds-qty]');
    if (!wrap) return;
    var out = wrap.querySelector('[data-ds-qty-value]');
    var val = Math.max(1, parseInt(out.textContent, 10) + parseInt(btn.getAttribute('data-ds-qty-step'), 10));
    D.querySelectorAll('[data-ds-qty-value]').forEach(function (o) { o.textContent = val; });
    D.dispatchEvent(new CustomEvent('ds:qty', { detail: { qty: val } }));
  });

  /* ---------- Arranque ---------- */
  function init() {
    /* O menu mobile vive dentro do header sticky (stacking context limitado):
       portar para o body para poder ficar acima de tudo. */
    var mnav = D.getElementById('ds-mobile-nav');
    if (mnav && mnav.parentElement !== D.body) D.body.appendChild(mnav);

    initHero();
    initSearch();
    fetchCart();
    wishSync();
    initClamp();
    initScrollWraps();
    syncNewsletterButtons();
    syncFooterDetails();
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(syncFooterDetails, 150);
    });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
